import { SiteRules } from "../shared/SiteRules";
import { Show } from "./models/Show";
import { Page } from "./models/Page";

export class ToutvSiteRules extends SiteRules {
  override get isTrackingEnabled(): boolean {
    const forbiddenPages = ["categorie:jeunesse", "categorie:pour-les-petits", "section:jeunesse"];
    const show = dataLayerHelper.get<Show>("show");
    const page = dataLayerHelper.get<Page>("page");
    if (page?.name && forbiddenPages.includes(page.name.toLowerCase())) {
      return false;
    }
    return show?.trackForAds?.toLowerCase() !== "false";
  }
}
